import React, { Component } from 'react';

class Loading extends Component {
   state = {
      data: []
   }
   
   componentDidMount() {
      
   }
   
   render() {
      return (
         <div className="content-page" style={{position:'fixed', width:'100%', height:'100vh', padding: '0'}}>
            <div style={{position:'absolute', height:'54px',width:'54px', top:'46%', left:'50%', marginLeft:'-20px', textAlign:'center'}}>
               <div className="loader" style={{height:'24px', width:'24px', borderColor:'#00880d', borderTopColor:'#ddd', margin:'auto'}}></div>
            </div>
         </div>
         )
      }
   }

   export default Loading;